<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    viewBox="0 0 100 100">
    <path
      d="M40.2 9.2c-16.6 11.3-21 33.8-9.8 50.5L5.1 84.9c-2.8 2.8-2.8 7.3 0 10 2.8 2.8 7.3 2.8 10 0l25.3-25.3c6 4.1 13.1 6.2 20.3 6.2 20.1 0 36.4-16.3 36.4-36.4C97.1 19.3 80.8 3 60.7 3c-7.3 0-14.4 2.2-20.5 6.2zm20.7 7.9C73.1 17.2 83 27.2 83 39.4c0 12.3-10 22.3-22.3 22.3s-22.3-10-22.3-22.3 10-22.3 22.3-22.3h.2z" />
  </svg>
</template>
